<ng-container *ngIf="sortable; else labelOnly">
  <div *ngIf="interactive; else standardControl" class="ia-header-interactive">
    <div class="ia-header-content"><ng-container *ngTemplateOutlet="content"></ng-container></div>
    <button #sortControl type="button" class="ia-header-icon-control" [attr.aria-label]="accessibleLabel"
      [attr.aria-description]="action" [title]="action" (click)="activate($event)">
      <ng-container *ngTemplateOutlet="indicator"></ng-container>
    </button>
  </div>
  <ng-template #standardControl>
    <button *ngIf="!titleTemplate; else blockControl" #sortControl type="button" class="ia-header-control ia-header-control--plain"
      [attr.aria-label]="accessibleLabel" [attr.aria-description]="action" [title]="action" (click)="activate($event)">
      <span class="ia-header-text">{{ label }}</span><ng-container *ngTemplateOutlet="indicator"></ng-container>
    </button>
    <ng-template #blockControl>
      <!-- Custom block titles retain their layout without invalid block content inside a native button. -->
      <div #sortControl role="button" tabindex="0" class="ia-header-control ia-header-control--custom"
        [class.ia-header-control--sorted]="!!direction" [attr.aria-label]="accessibleLabel" [attr.aria-description]="action"
        (click)="activate($event)" (keydown)="onKeydown($event)">
        <ng-container *ngTemplateOutlet="content"></ng-container><ng-container *ngTemplateOutlet="indicator"></ng-container>
      </div>
    </ng-template>
  </ng-template>
</ng-container>
<ng-template #labelOnly><div class="ia-header-label" [class.ia-header-label--plain]="!titleTemplate"><ng-container *ngTemplateOutlet="content"></ng-container></div></ng-template>
<ng-template #content>
  <ng-container *ngIf="titleTemplate; else plainLabel"><ng-container *ngTemplateOutlet="titleTemplate; context: {col: column, index: index}"></ng-container></ng-container>
  <ng-template #plainLabel>{{ label }}</ng-template>
</ng-template>
<ng-template #indicator>
  <span class="ia-header-indicator" [class.ia-header-indicator--active]="!!direction" aria-hidden="true">
    <svg *ngIf="direction; else neutral" width="12" height="12" viewBox="0 0 12 12" fill="none" [class.ia-header-indicator--descending]="direction === 'desc'"><path d="M6 10V2M2.5 5.5 6 2l3.5 3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
    <ng-template #neutral><svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M3.5 10V2M1 4.5 3.5 2 6 4.5M8.5 2v8M6 7.5 8.5 10 11 7.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg></ng-template>
  </span>
</ng-template>
